<script>
  import ModalCard from '../ModalCard.svelte'
  import RouteLogView from '../../views/RouteLogView.svelte'

  let modal
  let log

  // モーダルを開く
  export const open = (target) => {
    log = target
    modal.show()
  }

  // 確認ボタンを押したら削除
  const confirmHandler = () => log.ref.delete()
</script>

<ModalCard
  name="routeLogDeleter"
  title={`走行記録-削除`}
  buttonText="削除実行"
  buttonClass="is-warning"
  {confirmHandler}
  bind:this={modal}
>
  {#if log}
    <RouteLogView name={`routeLogDeleter`} {log} />
  {/if}
  <p slot="footer">上記の走行記録を削除しますか？</p>
</ModalCard>
